<template>
    <el-col :xs="{span:24}" :md="settings.Width" class="el-form-item--large" :class="className" v-show="defaultShow">
        <el-collapse class="QweCollapse" v-model="activeName" accordion>
            <el-collapse-item 
                v-for="(item,index) in settings.Childrens"
                :key="index"
                :name = "item.Title"
                v-show="item.Display">
                <template #title>
                    <i :class="item.Prefix"></i>
                    {{ item.Title }}
                    <i :class="item.Suffix"></i>
                </template>
                <div class="collapse-row el-row">
                    <component v-for="field in item.Components"
                                :key="field.Name"
                                :is="field.FieldDefinition.Name"
                                :definition="field"
                                :data="data"
                                :htmlPrefix="htmlPrefix"
                                :contentType="contentType"
                                :formDefinition = "formDefinition"
                                :orginalDisplay = "orginalDisplay">
                    </component>
                </div>
            </el-collapse-item>
        </el-collapse>
    </el-col>
</template>

<script>
    import BaseLayout from "./LayoutBase";
    export default {
        name:"qweCollapse",
        mixins: [BaseLayout],
        data: function () {
        return {
                activeName: ""
            };
        },
        created: function () {
            this.activeName = this.settings.activeName;
            this.settings.Childrens.forEach(x => {
                x.Display = true;
            });
        },

        watch:{
            "errorEventBus":function(){
                let errorComponentPath = this.errorComponentPath;
                let index = errorComponentPath.findIndex(x=> x.Field == this.name);
                if(index >-1){
                    let activeName = errorComponentPath[index].Active;
                    this.activeName = activeName;
                }
            }
        },

        computed:{
            display:function(){
                return true;
            }
        },
        methods: {
            initLayoutBase: function () {
                this.settings = this.definition.Settings;
            }
        }
    }
</script>